export const DEFAULT_IMAGE_URL = 'https://ucarecdn.com/33122bef-7104-464f-a66b-f6c90b0f48a4/-/autorotate/yes/';

export const LABEL_CLASS = 'text-3xl mt-10 mb-2 ml-4 sm:mt-12 sm:ml-0 font-normal';
